module.exports = __webpack_public_path__ + "static/media/splash-banner-background.3d66b142.png";